import { useTranslation } from "@refinedev/core";

import { Button, Paper, Stack, Typography } from "@mui/material";

export interface ReactivateConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ReactivateConfirmDialog = ({ open, onConfirm, onCancel }: ReactivateConfirmDialogProps) => {
  const { translate } = useTranslation();

  if (!open) {
    return null;
  }

  const prefix = "pages.practitioner.editModal.reactivateConfirm";

  const title = translate(`${prefix}.title`);
  const description = translate(`${prefix}.description`);
  const confirmLabel = translate(`${prefix}.confirm`);
  const cancelLabel = translate(`${prefix}.cancel`);

  return (
    <Paper elevation={0} variant="alertSuccess" data-testid="reactivate-confirm-dialog">
      <Stack spacing={2} alignItems="center">
        <Typography variant="h3" textAlign="center" color="text.primary">
          {title}
        </Typography>

        <Typography variant="body2" textAlign="center" color="text.primary">
          {description}
        </Typography>

        <Stack direction="row" spacing={2} pt={1}>
          <Button
            variant="outlined"
            size="large"
            color="primary"
            onClick={onCancel}
            data-testid="reactivate-confirm-dialog-cancel"
          >
            {cancelLabel}
          </Button>
          <Button
            variant="capsule"
            color="success"
            onClick={onConfirm}
            data-testid="reactivate-confirm-dialog-confirm"
            autoFocus
          >
            {confirmLabel}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
};
